import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { PRACTICE } from "../../lib/data";
import useReveal from "../../hooks/use-reveal";

export const Visit = () => {
  useReveal();
  return (
    <section id="visit" className="py-20 sm:py-28 px-6 sm:px-10 lg:px-14 bg-paper">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 reveal">
          <p className="eyebrow mb-3">Where to Find Us</p>
          <h2 className="font-sans font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-ink leading-tight">
            Visit Us
          </h2>
        </div>

        <div className="reveal bg-bone-2 rounded-3xl border border-line p-8 sm:p-12">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <Card icon={MapPin} label="Address">
              {PRACTICE.address}
            </Card>
            <Card icon={Phone} label="Phone">
              <a href={`tel:${PRACTICE.phone.replace(/\s/g, "")}`} className="link-underline" data-testid="visit-phone-1">
                {PRACTICE.phone}
              </a>
              <br />
              <a href={`tel:${PRACTICE.phoneAlt.replace(/\s/g, "")}`} className="link-underline text-sm" data-testid="visit-phone-2">
                {PRACTICE.phoneAlt}
              </a>
            </Card>
            <Card icon={Clock} label="Hours">
              {PRACTICE.hours}
            </Card>
          </div>

          <div className="flex flex-wrap gap-3 justify-center">
            <a
              href={`tel:${PRACTICE.phone.replace(/\s/g, "")}`}
              data-testid="visit-call-btn"
              className="btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-sm font-semibold"
            >
              <Phone size={16} />
              Call Now
            </a>
            <a
              href={`https://wa.me/${PRACTICE.whatsapp}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="visit-whatsapp-btn"
              className="btn-outline inline-flex items-center gap-2 px-7 py-3.5 rounded-full text-sm font-semibold bg-paper"
            >
              <MessageCircle size={16} />
              WhatsApp Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

const Card = ({ icon: Icon, label, children }) => (
  <div className="bg-paper border border-line rounded-2xl p-6 text-center">
    <div className="w-11 h-11 rounded-full bg-bone-2 text-forest flex items-center justify-center mx-auto mb-4">
      <Icon size={18} strokeWidth={1.8} />
    </div>
    <p className="eyebrow mb-2">{label}</p>
    <p className="text-sm sm:text-base text-ink leading-snug">{children}</p>
  </div>
);
